import React from 'react';
import Box from '@mui/material/Box';
import AssetByCategoryChart from './Charts/AssetCategoryChart.tsx';
import AssetByManufacturerChart from './Charts/AssetByManufacturerChart.tsx';
import AssetByEndDateChart from './Charts/AssetByEndDateChart.tsx';
import GraphBox from '../../../components/GraphBox/GraphBox.tsx';
import AssetByManufacturerType from '../../../components/GraphBox/GraphViewControlBar/GraphViewControlBarTypes/AssetByManufacturerType.tsx';
import AssetCategoryType from '../../../components/GraphBox/GraphViewControlBar/GraphViewControlBarTypes/AssetCategoryType.tsx';
import type { GraphViewOption } from '../../../components/GraphBox/GraphViewControlBar/GraphViewControlBar.tsx';
import AssetByClientAttributesType from '../../../components/GraphBox/GraphViewControlBar/GraphViewControlBarTypes/AssetByClientAttributesType.tsx';
import AssetByClientAttributesChart from './Charts/AssetByClientAttributesChart.tsx';
import InvoiceDetailsChart from './Charts/InvoiceDetailsChart.tsx';
import InvoiceDetailsType from '../../../components/GraphBox/GraphViewControlBar/GraphViewControlBarTypes/InvoiceDetailsType.tsx';
import {
    ASSET_CATEGORY_CHART,
    ASSET_BY_MANUFACTURER_CHART,
    ASSET_BY_CLIENT_ATTRIBUTES_CHART,
    INVOICE_DETAILS_CHART,
    ASSET_BY_END_OF_LEASE_DATE_CHART
} from '../../../constants/messages';
import AssetByEndOfLeaseType from '../../../components/GraphBox/GraphViewControlBar/GraphViewControlBarTypes/AssetByEndOfLeaseType.tsx';

/**
 * ChartGrid component - Displays a responsive grid of charts
 * @returns {JSX.Element} Grid containing pie and bar charts
 */

export interface ChartDropdown {
  options: GraphViewOption[];
  selection: GraphViewOption;
  onChange: (newView: { label: string; id: string }) => void;
}

// Simple chart configuration
export interface ChartConfig {
  type: 'pie' | 'bar';
  title: string;
  props: Record<string, any>; // Simple props object that matches chart requirements
  dropdownOptions?: ChartDropdown;
}

const SummaryGraphContainer: React.FC = () => {
	return (
		<Box
			sx={{
				width: '100%',
				display: 'flex',
				flexDirection: { xs: 'column', md: 'row' },
				flexWrap: 'wrap',
				gap: { xs: 2, md: '4%' },
			}}
		>
			<GraphBox title={ASSET_CATEGORY_CHART} ControlBar={AssetCategoryType}>
				<AssetByCategoryChart />
			</GraphBox>
			<GraphBox title={ASSET_BY_MANUFACTURER_CHART} ControlBar={AssetByManufacturerType}>
				<AssetByManufacturerChart />
			</GraphBox>
			<GraphBox title={ASSET_BY_CLIENT_ATTRIBUTES_CHART} ControlBar={AssetByClientAttributesType}>
				<AssetByClientAttributesChart />
			</GraphBox>
			<GraphBox title={INVOICE_DETAILS_CHART} ControlBar={InvoiceDetailsType}>
				<InvoiceDetailsChart />
			</GraphBox>
            <GraphBox
                title={ASSET_BY_END_OF_LEASE_DATE_CHART}
                ControlBar={AssetByEndOfLeaseType}
				fullWidth={true}
            >
                <AssetByEndDateChart />
            </GraphBox>
		</Box>
	);
};

export default SummaryGraphContainer;
